import {
  form,
  Form as AppForm,
  FormInput,
  FormRow
} from "MODULES/shared/components/Forms";
import { Field } from "redux-form";
import React from "react";

import ShippingFields from "MODULES/Orders/shared/ShippingFields/ShippingFields";
import {
  SHIP_TO,
  SHIP_TO_COMPANY_ADDRESS_ID,
  SHIP_TO_COMPANY_ID,
  SHIP_TO_FOB,
  SHIP_TO_SHIPPING_ADDRESS,
  SHIP_TO_SHIPPING_METHOD,
  SHIP_TO_TYPE
} from "APP_ROOT/constants";
import { connect } from "react-redux";
import * as actions from "MODULES/inventories/actions";
import { fobFormat } from "LIB/formatters/address";
import { Col } from "react-bootstrap";
import { COMPANY } from "MODULES/companies/constants";
import validate from "./validate";

const FORM_NAME = "createInventoryShipmentForm";

export function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <h4>Ship To</h4>
        <ShippingFields
          key="ship-to-shipping-fields"
          formName={FORM_NAME}
          hasLocations={false}
          path={SHIP_TO}
          renderCarrier
          shippingFields={[
            SHIP_TO_TYPE,
            SHIP_TO_COMPANY_ID,
            SHIP_TO_COMPANY_ADDRESS_ID
          ]}
          shippingMethod={SHIP_TO_SHIPPING_METHOD}
          shippingTypes={[COMPANY]}
          shippingAddressField={SHIP_TO_SHIPPING_ADDRESS}
          required
        />
        <FormRow>
          <Col md={6}>
            <div className="form-group">
              <Field
                name={SHIP_TO_FOB}
                component={FormInput}
                label="FOB"
                required
              />
            </div>
          </Col>
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(
  (state, ownProps) => ({
    initialValues: {
      [SHIP_TO_FOB]: fobFormat(ownProps.inventory.store_location),
      [SHIP_TO_TYPE]: COMPANY
    }
  }),
  (dispatch, ownProps) => ({
    onSubmit: data =>
      dispatch(actions.returnToCustomer(ownProps.inventory.id, data))
  })
)(
  form({
    form: FORM_NAME,
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/CreateInventoryShipment/Form.jsx